import { Button } from 'components/v2/atoms/button';
import useGlobalStore from 'store/global';

interface IzanaviFeatureCardType {
  icon: string;
  title: string;
  description: string;
}

const IzanaviFeatureCard = ({
  icon,
  title,
  description,
}: IzanaviFeatureCardType) => {
  return (
    <div className="rounded-2xl border-2 border-pp-border-primary bg-white p-8 shadow-lg transition-all duration-300 hover:-translate-y-2 hover:shadow-xl">
      <div className="mb-4 flex items-center">
        <div className="mr-3 text-4xl">{icon}</div>
        <h3 className="text-xl font-bold text-pp-green-primary">{title}</h3>
      </div>
      <p className="text-base leading-relaxed text-pp-text-secondary">
        {description}
      </p>
    </div>
  );
};

const IzanaviSection = () => {
  const showIzanaviPRDialog = useGlobalStore(
    (state) => state.showIzanaviPRDialog,
  );
  const currentAuth = useGlobalStore((state) => state.currentAuth);
  const showLogin = useGlobalStore((state) => state.showLogin);
  const features: IzanaviFeatureCardType[] = [
    {
      icon: '📊',
      title: 'メーター機能',
      description:
        '60以上のチャートパターンを検知し、チャートパターンが多い時/少ない時を通知してくれます。市場の動きを見逃しません。',
    },
    {
      icon: '📈',
      title: '過去のチャート分析',
      description:
        'それぞれのマーケットの過去のチャートに適用し、シグナルが多い日/少ない日を矢印で表示。トレンドを視覚的に把握できます。',
    },
  ];

  return (
    <section className="w-full bg-pp-bg-secondary px-6 py-20">
      <div className="mx-auto max-w-5xl">
        {/* Header */}
        <div className="mb-12 text-center">
          <div className="mb-4 inline-block rounded-full bg-pp-green-primary px-6 py-2 text-white">
            <span className="text-sm font-bold">
              Platinumメンバー限定オプション
            </span>
          </div>
          <h2 className="mb-6 text-4xl font-bold text-pp-text-primary md:text-5xl">
            IZANAVI
          </h2>
          <p className="text-lg text-pp-text-secondary md:text-xl">
            AIが市場の騰落シグナルをリアルタイムで通知
          </p>
        </div>

        {/* What is IZANAVI */}
        <div className="mb-8 rounded-3xl bg-pp-green-subtle p-10 shadow-xl transition-all duration-300 hover:-translate-y-2 hover:shadow-2xl">
          <div className="flex items-start">
            <div className="mr-4 text-5xl">🤖</div>
            <div>
              <h3 className="mb-3 text-2xl font-bold text-pp-green-primary">
                IZANAVIとは
              </h3>
              <p className="text-lg leading-relaxed text-pp-text-secondary">
                取引時間内のトレーディング市場で騰落に有力なシグナルが現れた際、リアルタイムで通知するAIパートナー。過去30年以内のデータを機械学習しており、60以上のチャートパターンでユーザーに騰落傾向を通知します。
              </p>
            </div>
          </div>
        </div>

        {/* Feature Cards */}
        <div className="mb-8 grid gap-6 md:grid-cols-2">
          {features.map((feature, index) => (
            <IzanaviFeatureCard
              key={index}
              icon={feature.icon}
              title={feature.title}
              description={feature.description}
            />
          ))}
        </div>

        {/* CTA Box */}
        <div className="rounded-2xl bg-white p-8 text-center shadow-lg">
          <div className="mb-4 flex items-center justify-center">
            <span className="mr-3 text-4xl">💎</span>
            <h3 className="text-lg font-bold text-pp-green-primary md:text-xl">
              Platinumメンバーシップのオプションプランとして提供
            </h3>
          </div>
          <p className="mb-6 text-base text-pp-text-secondary">
            より高度な市場分析と投資判断をサポートする、プレミアムAIツールです
          </p>
          <Button
            className="rounded-full bg-pp-green-primary px-8 py-3 text-base font-semibold text-white transition-all hover:scale-105 hover:bg-pp-green-hover"
            onClick={() => {
              if (!currentAuth) {
                showLogin({});
                return;
              }
              showIzanaviPRDialog(true);
            }}
          >
            IZANAVIについて詳しく見る
          </Button>
        </div>
      </div>
    </section>
  );
};

export default IzanaviSection;
